import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import React, { Component } from 'react';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

class MSPConfForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: props.data
    };
  }

  render() {
    const { item } = this.state;

    const {
      intl,
      company,
      colourStyles,
      dropdownKey,
      options,
      value
    } = this.props;

    return (
      <>
        <div className="w280 ml-12 mb-20" name={item.title}>
          <div> {item.title} </div>
          <Select
            value={value || undefined}
            label={item.title}
            options={options}
            onChange={this.props.onChange.bind(this, dropdownKey)}
            components={{ IndicatorSeparator, DropdownIndicator }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            menuPlacement="auto"
            placeholder={getTranslatedText(
              intl,
              'admin.mspDetails.placeholder'
            )}
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 })
            }}
          />
        </div>
      </>
    );
  }
}

export default injectIntl(MSPConfForm);
